// /Users/boyd/Dev/freegopos/my-web-app/src/components/CreateCustomerModal.tsx
import React, { useState, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { FiX } from 'react-icons/fi';
import { searchUser, getRegionsFromLicense } from '../utils/api'; // Import getRegionsFromLicense
import { useLocations } from '../context/LocationContext'; // Import useLocations
import { ApiCountry } from '../utils/types'; // Import ApiCountry type

interface CreateCustomerModalProps {
    isOpen: boolean;
    onClose: () => void;
    // onCreateCustomer: (name: string, email: string, phone: string) => Promise<void>;
    onCreateCustomer: (name: string, email: string, phone: string, countryCode: string) => Promise<void>;

}

const CreateCustomerModal: React.FC<CreateCustomerModalProps> = ({ isOpen, onClose, onCreateCustomer }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    // const [phone, setPhone] = useState('');
    const [localPhoneNumber, setLocalPhoneNumber] = useState(''); // For the number part after country code

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [userSearch, setUserSearch] = useState('');
    const [userResults, setUserResults] = useState<any[]>([]);
    const [selectedUser, setSelectedUser] = useState<any | null>(null);
    const [isEmailManuallyEdited, setIsEmailManuallyEdited] = useState(false);

    // const [searchLoading, setSearchLoading] = useState(false);
    const { countries: countryOptions, loadingCountries } = useLocations();
    const [selectedCountry, setSelectedCountry] = useState<ApiCountry | undefined>(undefined);
    const [licenseRegions, setLicenseRegions] = useState<string[]>([]);
    const [loadingLicenseRegions, setLoadingLicenseRegions] = useState<boolean>(true);

    // Fetch license regions
    useEffect(() => {
        const fetchLicenseData = async () => {
            setLoadingLicenseRegions(true);
            // Extract the base domain or use the full hostname as needed by your license API

            const currentDomain = window.location.hostname; // e.g., thaisignature.u8.my

            console.log('currentDomain', currentDomain);
            
            // const currentDomain = 'https://thaisignature.u8.my/'.replace('https://', '').replace('http://', '').replace('/', '').replace('.', '_');


            // You might need to process currentDomain if your license API expects a root domain like "u8.my"
            const regions = await getRegionsFromLicense(currentDomain);
            setLicenseRegions(regions);
            setLoadingLicenseRegions(false);
        };
        fetchLicenseData();
    }, []);

    // Set default country to Malaysia
    useEffect(() => {
        // if (countryOptions.length > 0 && !selectedCountry) {
        //     const malaysia = countryOptions.find(c => c.iso2 === 'MY');
        //     setSelectedCountry(malaysia || countryOptions[0]);

        if (countryOptions.length > 0 && !selectedCountry && !loadingLicenseRegions) {
            let defaultCountry: ApiCountry | undefined;
            if (licenseRegions.length > 0) {
                // Try to find a country from license regions (assuming region ID matches country.id)
                defaultCountry = countryOptions.find(c => licenseRegions.includes(String(c.id)));
            }
            // Fallback to Malaysia or the first country
            defaultCountry = defaultCountry || countryOptions.find(c => c.iso2 === 'MY') || countryOptions[0];
            setSelectedCountry(defaultCountry);
        }
        // }, [countryOptions, selectedCountry]);
    }, [countryOptions, selectedCountry, licenseRegions, loadingLicenseRegions]);


    // const handleUserSearch = async (query: string) => {
    //     setSearchLoading(true);
    //     try {
    //         // Replace with your actual API call
    //         const res = searchUser(query);
    //         console.log('User search results:', res);

    //         // setUserResults(res.data || []); // Assuming res is the direct data or res.data
    //     } catch (err) {
    //         setUserResults([]);
    //     } finally {
    //         setSearchLoading(false);
    //     }
    // };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        const fullPhoneNumber = (selectedCountry?.phonecode || '') + localPhoneNumber.replace(/^0+/, '');

        if (!name.trim()) {
            setError('Name is required.');
            toast.error('Name is required.');
            return;
        }
        if (!email.trim()) {
            setError('Email is required.');
            toast.error('Email is required.');
            return;
        }
        // if (!phone.trim()) {
        if (!localPhoneNumber.trim()) {

            setError('Phone number is required.');
            toast.error('Phone number is required.');
            return;
        }
        // Basic email validation
        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Please enter a valid email address.');
            toast.error('Please enter a valid email address.');
            return;
        }
        // if (!/^\d{10,15}$/.test(phone)) {
        // Validate the full phone number (country code + local part)
        if (!/^\d{7,15}$/.test(fullPhoneNumber.replace(/\D/g, ''))) { // Allow 7-15 digits total

            setError('Please enter a valid phone number (10-15 digits).');
            toast.error('Please enter a valid phone number (10-15 digits).');
            return;
        }

        setIsLoading(true);

        try {
            // await onCreateCustomer(name, email, phone);
            await onCreateCustomer(name, email, fullPhoneNumber, selectedCountry?.iso2 || '');

            toast.success('Customer created successfully!');
            setName(''); // Reset form
            setEmail('');
            // setPhone('');
            setLocalPhoneNumber('');
            // Optionally reset selectedCountry to default if needed

            onClose(); // Close modal on success
        } catch (err: any) {
            const errorMessage = err.response?.data?.message || err.message || 'Failed to create customer.';
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    // const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const newPhone = e.target.value;
    //     setPhone(newPhone);
    //     if (!isEmailManuallyEdited) {
    //         setEmail(`${newPhone}@u8.my`);
    const handleLocalPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newLocalPart = e.target.value.replace(/\D/g, '').replace(/^0+/, ''); // Allow only digits
        setLocalPhoneNumber(newLocalPart);
        if (!isEmailManuallyEdited && selectedCountry) {
            setEmail(`${selectedCountry.phonecode}${newLocalPart}@u8.my`);

        }
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setIsEmailManuallyEdited(true); // Mark email as manually edited
    };

    const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const countryIso2 = e.target.value;
        const country = countryOptions.find(c => c.iso2 === countryIso2);
        setSelectedCountry(country);
        // If phone number exists and email not manually edited, update email
        if (localPhoneNumber && !isEmailManuallyEdited && country) {
            setEmail(`${country.phonecode}${localPhoneNumber}@u8.my`);
        } else if (!isEmailManuallyEdited) {
            setEmail(''); // Clear email if no phone number or country
        }
    };

    // Prepare sorted country options for the dropdown
    const sortedCountryOptions = useMemo(() => {
        // if (loadingCountries || countryOptions.length === 0) {
        if (loadingCountries || loadingLicenseRegions || countryOptions.length === 0) {

            return [];
        }
        const prioritizedCountries: ApiCountry[] = [];
        const otherCountriesList = [...countryOptions];

        // 1. Add countries from license regions first
        licenseRegions.forEach(regionId => {
            const country = otherCountriesList.find(c => String(c.id) === regionId);
            if (country) {
                prioritizedCountries.push(country);
                // Remove from otherCountriesList to avoid duplicates
                otherCountriesList.splice(otherCountriesList.indexOf(country), 1);
            }
        });

        // 2. Add Malaysia if not already added
        const malaysia = countryOptions.find(c => c.iso2 === 'MY');
        if (malaysia && !prioritizedCountries.some(pc => pc.id === malaysia.id)) {
            prioritizedCountries.push(malaysia);
            if (otherCountriesList.includes(malaysia)) otherCountriesList.splice(otherCountriesList.indexOf(malaysia), 1);
        }
        // 3. Add Thailand if not already added

        const thailand = countryOptions.find(c => c.iso2 === 'TH');

        //     const otherCountries = countryOptions.filter(

        //         c => c.iso2 !== 'MY' && c.iso2 !== 'TH'
        //     );

        //     const sorted: ApiCountry[] = [];
        //     if (malaysia) sorted.push(malaysia);
        //     if (thailand) sorted.push(thailand);
        //     sorted.push(...otherCountries);
        //     return sorted;
        // }, [countryOptions, loadingCountries]);

        if (thailand && !prioritizedCountries.some(pc => pc.id === thailand.id)) {
            prioritizedCountries.push(thailand);
            if (otherCountriesList.includes(thailand)) otherCountriesList.splice(otherCountriesList.indexOf(thailand), 1);
        }

        // 4. Add remaining countries
        // Filter out any countries already in prioritizedCountries from otherCountriesList again just in case
        const remainingCountries = otherCountriesList.filter(oc => !prioritizedCountries.some(pc => pc.id === oc.id));
        prioritizedCountries.push(...remainingCountries);

        return prioritizedCountries;
    }, [countryOptions, loadingCountries, licenseRegions, loadingLicenseRegions]);


    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl z-10"
                    aria-label="Close create customer modal"
                >
                    <FiX size={24} />
                </button>
                <h2 className="text-xl font-bold mb-6">Create New Customer</h2>

                { /*
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Search User (not linked to any customer)
                    </label>
                    <input
                        type="text"
                        value={userSearch}
                        onChange={e => {
                            setUserSearch(e.target.value);
                            if (e.target.value.length >= 2) handleUserSearch(e.target.value);
                            else setUserResults([]);
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
                        placeholder="Type name or email..."
                        disabled={isLoading}
                    />
                    {searchLoading && <div className="text-xs text-gray-500">Searching...</div>}
                    {userResults.length > 0 && (
                        <ul className="border rounded bg-white mt-1 max-h-40 overflow-y-auto">
                            {userResults.map(user => (
                                <li
                                    key={user.id}
                                    className={`px-3 py-2 cursor-pointer hover:bg-indigo-100 ${selectedUser?.id === user.id ? 'bg-indigo-200' : ''}`}
                                    onClick={() => {
                                        setSelectedUser(user);
                                        setName(user.name || '');
                                        setEmail(user.email || '');
                                        setUserResults([]);
                                        setUserSearch('');
                                    }}
                                >
                                    {user.name} ({user.email})
                                </li>
                            ))}
                        </ul>
                    )}
                    {selectedUser && (
                        <div className="text-xs text-green-700 mt-1">
                            Selected: {selectedUser.name} ({selectedUser.email})
                            <button
                                type="button"
                                className="ml-2 text-red-500 underline"
                                onClick={() => setSelectedUser(null)}
                            >
                                Clear
                            </button>
                        </div>
                    )}
                </div>
                */ }


                {error && <p className="text-red-500 text-sm mb-4">const otherCountries = countryOptions.filter(
                    {error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="customerName" className="block text-sm font-medium text-gray-700 mb-1">
                            Full Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            id="customerName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    {/* <div className="mb-6"> */}
                    <div className="mb-4">

                        <label htmlFor="customerPhone" className="block text-sm font-medium text-gray-700 mb-1">
                            Phone No.<span className="text-red-500">*</span>
                        </label>
                        {/* <input
                            type="phone"
                            id="customerPhone"
                            value={phone}
                            // onChange={(e) => setPhone(e.target.value)}
                            onChange={handlePhoneChange}

                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            required
                            disabled={isLoading}
                        /> */}

                        <div className="flex flex-col">
                            <select
                                id="countryCode"
                                value={selectedCountry?.iso2 || ''}
                                onChange={handleCountryChange}
                                className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 text-sm"
                                disabled={isLoading || loadingCountries}
                            >
                                {/* {loadingCountries && <option>Loading...</option>} */}
                                {(loadingCountries || loadingLicenseRegions) && <option>Loading countries...</option>}

                                {/* {!loadingCountries && countryOptions.map(country => ( */}
                                {!loadingCountries && sortedCountryOptions.map(country => (

                                    <option key={country.iso2} value={country.iso2}>
                                        {country.name} - {country.iso2} (+{country.phonecode})
                                    </option>
                                ))}
                            </select>
                            <input
                                type="tel" // Changed to tel
                                id="customerPhone"
                                value={localPhoneNumber}
                                onChange={handleLocalPhoneChange}
                                placeholder="e.g., 1112163808"
                                className="w-full px-3 py-2 border border-l-0 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                                required
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                    <div className="mb-6">
                        <label htmlFor="customerEmail" className="block text-sm font-medium text-gray-700 mb-1">
                            Email Address <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            id="customerEmail"
                            value={email}
                            // onChange={(e) => setEmail(e.target.value)}
                            onChange={handleEmailChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="flex items-center justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isLoading}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                        >
                            {isLoading ? 'Creating...' : 'Create Customer'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateCustomerModal;
